
import styled from 'styled-components'
import { BORDER_RADIUS } from './BorderRadius'

const BlogImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: ${BORDER_RADIUS};
`

export default BlogImage